import { Box } from '@mui/material';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { MessageType } from '../../../../../../types/chat.types';
import { useChatMessagesContext } from '../../../../contexts/chatMessages.context';
import { ChatMessageAcceptedMessageTypesToFilter } from '../../../../contexts/reducer/chatMessages.state.types';
import AlterMessageTypeButton from './components/AlterMessageTypeButton/AlterMessageTypeButton';

export const ALTER_MESSAGE_TYPE_ACTIONS_MAX_HEIGHT = '56px';

const MESSAGE_TYPES: ChatMessageAcceptedMessageTypesToFilter[] = [
  MessageType.IMAGE_OR_VIDEO,
  MessageType.FILE,
];

const TEXT: Record<ChatMessageAcceptedMessageTypesToFilter, LangEnum> = {
  [MessageType.IMAGE_OR_VIDEO]: LangEnum.GLOBAL_IMAGES_OR_VIDEOS,
  [MessageType.FILE]: LangEnum.GLOBAL_DOCUMENTS,
};

const ChatMessageAlterMessageTypeActions = () => {
  const { filterMessagesBy, filteringMessagesByType } = useChatMessagesContext();

  return (
    <Box
      sx={{
        pt: '8px',
        pl: '12px',
        pr: '12px',
        pb: '12px',
        display: 'flex',
        gap: '4px',
        maxHeight: ALTER_MESSAGE_TYPE_ACTIONS_MAX_HEIGHT,
      }}
    >
      <AlterMessageTypeButton
        isSelected={!filteringMessagesByType}
        onClick={() => filterMessagesBy()}
        text={LangEnum.CHAT_ROOMS_HEADER_MESSAGE}
      />
      {MESSAGE_TYPES.map((type) => (
        <AlterMessageTypeButton
          key={type}
          text={TEXT[type]}
          onClick={() => filterMessagesBy(type)}
          isSelected={filteringMessagesByType === type}
        />
      ))}
    </Box>
  );
};

export default ChatMessageAlterMessageTypeActions;
